import { defineMessages } from "react-intl";

export const KYC_AIR_PAGE_MESSAGES = defineMessages({
  additionalInfoRequired: {
    id: "KYC AIRs: Additional Information Required",
    defaultMessage: "Additional Information Required",
  },
  weNeedAFewMoreDetails: {
    id: "KYC Air: We need a few more details",
    defaultMessage: "We need a few more details",
  },
  uploadDocuments: { id: "KYC Air: Upload documents", defaultMessage: "Upload documents" },
  uploadDocument: { id: "KYC Air: Upload document", defaultMessage: "Upload document" },
  uploadDocumentsToProvideAdditionalContext: {
    id: "KYC Air: Optional: Upload any documents that may provide additional context or help our legal team review your data",
    defaultMessage:
      "Optional: Upload any documents that may provide additional context or help our legal team review your data",
  },
  uploadDocumentMissing: {
    id: "KYC Air: Please either upload at least one file, or explain why no file has been uploaded.",
    defaultMessage: "Please either upload at least one file, or explain why no file has been uploaded.",
  },
  uploadRequiredDocument: {
    id: "KYC Air: Please upload the required file",
    defaultMessage: "Please upload the required file.",
  },
  tooManyDocumentsUploaded: {
    id: "KYC Air: Only one document can be uploaded. Please remove any extra documents.",
    defaultMessage: "Only one document can be uploaded. Please remove any extra documents.",
  },
  completeRequest: { id: "KYC Air: Complete request", defaultMessage: "Complete request" },
  back: { id: "Back", defaultMessage: "Back" },
  commentRequiredLabel: { id: "KYC Air: Answer", defaultMessage: "Answer" },
  commentOptionalLabel: {
    id: "KYC Air: Add any additional context that may help our legal team review your data",
    defaultMessage: "Add any additional context that may help our legal team review your data",
  },
  responseMissingText: {
    id: "KYC Air: Answer is a required field",
    defaultMessage: "Answer is a required field",
  },
  optionalText: {
    id: "KYC Air: Optional",
    defaultMessage: "Optional",
  },
  weNeedMoreInformationForBanking: {
    id: "KYC Air: We need some more information to complete your banking application",
    defaultMessage: "We need some more information to complete your banking application.",
  },
});

export const KYC_AIR_SUMMARY_MESSAGES = defineMessages({
  proofOfBusinessAddress: {
    id: "KYC AIRs: Proof of Business Address",
    defaultMessage: "Proof of Business Address",
  },
  connectionBetweenLegalEntityAndBrand: {
    id: "KYC AIRs: Connection Between Legal Entity And Brand",
    defaultMessage: "Connection Between Legal Entity And Brand",
  },
  missingFromHandelsRegister: {
    id: "KYC AIRs: Missing From Handelsregister",
    defaultMessage: "Missing From Handelsregister",
  },
  missingFromHandelsRegisterGeneral: {
    id: "KYC AIRs: Missing From Handelsregister General",
    defaultMessage: "Missing From Handelsregister General",
  },
  proofOfPersonAddressDoesNotMeetRequirements: {
    id: "KYC AIRs: Proof Of Individual's Address Does Not Meet Requirements",
    defaultMessage: "Proof Of Individual's Address Does Not Meet Requirements",
  },
  legalProceedings: {
    id: "KYC AIRs: Legal Proceedings",
    defaultMessage: "Legal Proceedings",
  },
  registryStatus: {
    id: "KYC AIRs: Registry Status",
    defaultMessage: "Registry Status",
  },
  tradingHistory: {
    id: "KYC AIRs: Trading History",
    defaultMessage: "Trading History",
  },
  genericQuestion: {
    id: "KYC AIRs: More Information Needed",
    defaultMessage: "More Information Needed",
  },
  unitPassport: {
    id: "KYC AIRs: Passport Needed",
    defaultMessage: "Passport Needed for {name}",
  },
  unitAddressVerification: {
    id: "KYC AIRs: Address Verification",
    defaultMessage: "Address Verification for {name}",
  },
  unitSocialSecurityCard: {
    id: "KYC AIRs: Social Security Number",
    defaultMessage: "Social Security Number for {name}",
  },
  unitCertificateOfIncorporation: {
    id: "KYC AIRs: Certificate Of Incorporation",
    defaultMessage: "Certificate Of Incorporation for {name}",
  },
  unitEmployerIdentificationNumberConfirmation: {
    id: "KYC AIRs: Employer Identification Number Confirmation",
    defaultMessage: "Employer Identification Number Confirmation for {name}",
  },
});

export const KYC_AIR_MESSAGES = defineMessages({
  proofOfBusinessAddress: {
    id: "KYC AIRs: Could you please provide proof of address for your business at the following location",
    defaultMessage:
      "Could you please provide proof of address for your business at the following location: <b>{address}</b>? Acceptable documents include a utility bill or a bank statement dated within the past 3 months.",
  },
  connectionBetweenLegalEntityAndBrand: {
    id: "KYC AIRs: Could you please provide a document verifying the connection between {legal_name} and the website {website}? A DBA (Doing Business As) document or an e-commerce platform receipt showing the association would work perfectly.",
    defaultMessage:
      "Could you please provide a document verifying the connection between <b>{legal_name}</b> and the website <b>{website}</b>? A DBA (Doing Business As) document or an e-commerce platform receipt showing the association would work perfectly.<br></br>Thank you!",
  },
  missingFromHandelsRegister: {
    id: "KYC AIRs: As your business is registered as a GbR and not listed in the Handelsregister",
    defaultMessage:
      "As your business is registered as a GbR and not listed in the Handelsregister, we kindly ask you to provide the following documents to proceed with verification:<ul><li><b>Gesellschaftervertrag</b> (Partnership Agreement),</li><li><b>Gewerbeanmeldung</b> (Trade Registration)</li></ul>Please upload these at your earliest convenience, or let us know if you have any questions.",
  },
  missingFromHandelsRegisterGeneral: {
    id: "KYC AIRs: During our KYC review, we were unable to retrieve your company details from Handelsregister",
    defaultMessage:
      "During our KYC review, we were unable to retrieve your company details from Handelsregister. To complete our checks, please provide <ul><li>A recent company extract</li><li>A list of shareholders</li></ul>Once received, we will proceed with finalising your review.",
  },
  proofOfPersonAddressDoesNotMeetRequirements: {
    id: "KYC AIRs: Unfortunately, the proof of address provided does not meet our requirements and cannot be accepted",
    defaultMessage:
      "Unfortunately, the proof of address provided for <b>{name_of_person}</b> does not meet our requirements and cannot be accepted. Please provide a new utility bill or bank statement for them dated within the last 3 months, showing their full name and current residential address.",
  },
  legalProceedings: {
    id: "KYC AIRs: During our business verification review, we identified legal proceeding(s) involving your company. Please clarify the nature of the lawsuit, the current status of the proceedings, and any settlement agreements or court decisions if the matter has been resolved",
    defaultMessage:
      "During our business verification review, we identified legal proceeding(s) involving your company. Please clarify the nature of the lawsuit, the current status of the proceedings, and any settlement agreements or court decisions if the matter has been resolved.",
  },
  registryStatus: {
    id: "KYC AIRs: Your business filing status with the registry is listed as XXXXXXX and needs to be resolved before we can proceed",
    defaultMessage:
      "Your business filing status with the registry is listed as <b>{status}</b> and needs to be resolved before we can proceed. Please provide a receipt or confirmation document from the registry to confirm the filing status has been resolved.",
  },
  tradingHistory: {
    id: "KYC AIRs: Your company has been incorporated for less the 6 months. Could you confirm whether you have traded previously under a different company and provide supporting documentation?",
    defaultMessage:
      "Your company has been incorporated for less the 6 months. Could you confirm whether you have traded previously under a different company and provide supporting documentation?",
  },
  unitPassport: {
    id: "KYC AIRs: Please provide a copy of your unexpired passport",
    defaultMessage:
      "Please provide a copy of an unexpired passport for <b>{name}</b>.<br></br>The document must include both the identification page and the signed signature page, and the entire passport must be clearly visible with all edges fully in frame.",
  },
  unitAddressVerification: {
    id: "KYC AIRs: Please provide a document to verify the address for name of person or business",
    defaultMessage:
      "Please provide a document to verify the address of <b>{name}</b>, which was specified as <b>{address}</b>.<br></br>Acceptable documents include a utility bill, a bank statement or a lease agreement. For businesses, incorporation documents or an EIN letter are also acceptable.<br></br>Any document submitted for address verification must be dated within the past six months.",
  },
  unitSocialSecurityCard: {
    id: "KYC AIRs: Please provide a document verifying your Social Security Number (SSN)",
    defaultMessage:
      "Please provide a document verifying the Social Security Number (SSN) of <b>{name}</b>.<br></br>Acceptable documents include a filed tax return, a W-2 form or a copy of a social security card.",
  },
  unitCertificateOfIncorporation: {
    id: "KYC AIRs: Please provide a copy of your certificate of incorporation",
    defaultMessage:
      "Please provide a copy of your certificate of incorporation for your business <b>{name}</b>.<br></br><ul><li>For Corporations, please provide a certified copy of the Articles of Incorporation or Certificate of Incorporation.</li><li>For Partnerships, please provide a copy of the Partnership Agreement.</li><li>For LLCs, please provide a certified copy of the Articles of Organization.</li></ul>",
  },
  unitEmployerIdentificationNumberConfirmation: {
    id: "KYC AIRs: Please provide a document verifying your Federal EIN",
    defaultMessage:
      "Please provide a document verifying your Federal Employer Identification Number (EIN) for your business <b>{name}</b>.<br></br>Acceptable documents include a filed business tax return, an IRS 147c letter or the IRS Form CP 575.",
  },
});
